import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { apiFetch } from "../api/client";
import { Panel } from "../components/Panel";
import type { Conversation } from "../types";

export function ConversationsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["conversations"],
    queryFn: () => apiFetch<{ data: Conversation[] }>("/api/conversations"),
    refetchInterval: 5000,
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-semibold">Conversazioni</h2>
        <p className="mt-1 text-slate-400">Lista chat WhatsApp salvate dal webhook.</p>
      </div>

      <Panel>
        {isLoading ? (
          <p>Caricamento conversazioni...</p>
        ) : (
          <div className="divide-y divide-white/10">
            {(data?.data ?? []).length === 0 ? (
              <p className="py-6 text-sm text-slate-400">Nessuna conversazione WhatsApp ancora.</p>
            ) : null}
            {(data?.data ?? []).map((conversation) => (
              <div
                key={conversation.id}
                className="flex flex-wrap items-center justify-between gap-4 py-4"
              >
                <div className="min-w-0 flex-1">
                  <p className="font-semibold">{conversation.lead?.profile_name ?? conversation.lead?.phone}</p>
                  <p className="mt-1 max-w-3xl truncate text-sm text-slate-400">
                    {conversation.latest_message?.body ?? "Nessun messaggio"}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="rounded-full bg-emerald-400/10 px-3 py-1 text-xs font-medium text-emerald-300">
                    {conversation.status}
                  </span>
                  <Link
                    to={`/dahsbot/conversations/${conversation.id}`}
                    className="rounded-xl bg-emerald-400 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-emerald-300"
                  >
                    Apri chat
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </Panel>
    </div>
  );
}
